import { render, staticRenderFns } from "./Qwss.vue?vue&type=template&id=deac6242&scoped=true&"
import script from "./Qwss.vue?vue&type=script&lang=js&"
export * from "./Qwss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deac6242",
  null
  
)

export default component.exports